export default class AccountRegistrationController {
    constructor(AuthService, $state, RegisterService, ProfilePermissionsService, $window) {
        this.authService = AuthService;
        this.service = RegisterService;
        this.state = $state;
        this.permissionsService = ProfilePermissionsService;

        this.subscriptions = [];
        this.window = $window;
    }

    $onInit() {
        this.account = {
            name: '',
            country: 'DO'
        };
        this.hasProfiles = !!(this.window.localStorage.profilesCount && parseInt(this.window.localStorage.profilesCount) > 0);
    }
    $onDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    onCountrySelect(country){
        this.account.country = country;
    }

    registerAccount() {
        this.subscriptions.push(
            this.service.registerAccount(this.account.name, this.account.country).subscribe(
                (data) => {
                    if (data.account_token) {
                        this.profiles.push(data.profile);
                        this.permissionsService.setProfilesCount(
                            (parseInt(this.window.localStorage.profilesCount) || 0) + 1
                        );

                        this.authService.saveAccountToken(data.account_token);
                        this.permissionsService.setProfile(data.profile);
                        this.permissionsService.setProfilesCount(
                            (parseInt(this.window.localStorage.profilesCount) || 0) + 1
                        );

                        this.state.go('accountSubscription');
                    }
                },
                (error) => { }
            )
        );
        // }
    }

    logout() {
        this.subscriptions.push(
            this.authService.logout().subscribe(
                (data) => this.state.go('login'),
                (error) => { }
            )
        );
    }
}

AccountRegistrationController.$inject = ['AuthService', '$state', 'RegisterService', 'ProfilePermissionsService', '$window', 'SubscriptionService'];


// WEBPACK FOOTER //
// ./src/app/pages/account-registration/account-registration.controller.js